/**
 * When true, the app is in the process of logging out.
 * Used to suppress API error toasts that would otherwise show
 * (e.g. 403 from users/brands fetches) during or right after logout.
 */
let isLoggingOut = false;

export function getIsLoggingOut(): boolean {
  return isLoggingOut;
}

export function setLoggingOut(value: boolean): void {
  isLoggingOut = value;
}
